import { maxTools, toolDims } from '../constants';

export default function calculateToolboxHeight(maxToolsOverride?: number): number {
    return toolDims * ((maxToolsOverride ?? maxTools) + 2); // account for header + footer;
}
